import { FC } from 'react';
import classnames from 'classnames';
import { Props } from './types';
import DeviceManager from '../../../util/deviceManager';

const GameBookBtn: FC<Props> = ({ onToggle, hide }) => {
  if (hide) return null;
  const isMobile = DeviceManager.isMobile();
  return (
    <div className={classnames('game-book-button', isMobile && 'mobile')}>
      <div className={classnames('book-image')} onClick={onToggle} />
    </div>
  );
};

export default GameBookBtn;
